import { render } from "./PromotionCard.vue?vue&type=template&id=127733f6&scoped=true&ts=true"
import script from "./PromotionCard.vue?vue&type=script&lang=ts"
export * from "./PromotionCard.vue?vue&type=script&lang=ts"

import "./PromotionCard.vue?vue&type=style&index=0&id=127733f6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-127733f6"]])

export default __exports__